var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value
    ? _c(
        "FormWrapper",
        [
          _c("ChannelsIndicator", { attrs: { channels: _vm.channels } }),
          _vm._v(" "),
          _c(
            "FormControl",
            [
              _c("FormLabel", [
                _c("i", {
                  staticClass: "fa fa-lg text-muted fa-commenting mr-2",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("profile.form.sms")) + "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("ChannelMultiselect", {
                attrs: { channelType: "mobile" },
                model: {
                  value: _vm.channels.sms,
                  callback: function ($$v) {
                    _vm.$set(_vm.channels, "sms", $$v)
                  },
                  expression: "channels.sms",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormControl",
            [
              _c("FormLabel", [
                _c("i", {
                  staticClass:
                    "fa fa-lg text-muted fa-volume-control-phone mr-2",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("profile.form.text_to_speech")) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              !_vm.useDvFlagAccess("beepiz-shift-can:read")
                ? _c("div", {
                    staticClass: "alert alert-warning",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("profile.form.channels_pro_licences_warning")
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ChannelMultiselect", {
                attrs: {
                  channelType: "phone,mobile",
                  disabled: !_vm.useDvFlagAccess("beepiz-tts-can:read"),
                },
                model: {
                  value: _vm.channels.tts,
                  callback: function ($$v) {
                    _vm.$set(_vm.channels, "tts", $$v)
                  },
                  expression: "channels.tts",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormControl",
            [
              _c("FormLabel", [
                _c("i", {
                  staticClass: "fa fa-lg text-muted fa-envelope mr-2",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("profile.form.email")) + "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("ChannelMultiselect", {
                attrs: { channelType: "email" },
                model: {
                  value: _vm.channels.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.channels, "email", $$v)
                  },
                  expression: "channels.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }